import React, {FC} from 'react';

import {
  ComposerPanelId,
  ViewerPanelId,
} from '../../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {ApplicationComposerToolbarEntryPointModel} from '../../../../../models/api/applicationEntryPointModel';
import {ApplicationComposerEntryPointButtonContainer} from './applicationComposerEntryPointButtonContainer';
import {ApplicationComposerEntryPointOverflowButtonContainer} from './applicationComposerEntryPointOverflowButtonContainer';

/*
 * Constants.
 */

const overflowingEntryPointsCount = 3;

/*
 * Props.
 */

interface ApplicationComposerEntrypointButtonsProps {
  panelId: ComposerPanelId | ViewerPanelId;
  entryPoints: ReadonlyArray<ApplicationComposerToolbarEntryPointModel>;
  draftMessageUid: string;
  alwaysUseOverflowButton: boolean;
}

/*
 * Component.
 */

export const ApplicationComposerEntrypointButtons: FC<ApplicationComposerEntrypointButtonsProps> = (
  props,
) => {
  const {panelId, entryPoints, draftMessageUid, alwaysUseOverflowButton} = props;
  return (
    <>
      {!alwaysUseOverflowButton &&
        entryPoints
          .slice(0, overflowingEntryPointsCount)
          .map((entryPoint) => (
            <ApplicationComposerEntryPointButtonContainer
              key={entryPoint.frameId}
              panelId={panelId}
              entryPoint={entryPoint}
              draftMessageUid={draftMessageUid}
            />
          ))}
      <ApplicationComposerEntryPointOverflowButtonContainer
        entryPoints={alwaysUseOverflowButton ? entryPoints : entryPoints.slice(overflowingEntryPointsCount)}
        panelId={panelId}
        draftMessageUid={draftMessageUid}
      />
    </>
  );
};
